import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

// Update navLinks: remove "/user", add "/profiles"
const navLinks = [
  { to: "/inventory", label: "Inventory" },
  { to: "/profiles", label: "Friends" },
];

const Navbar: React.FC = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
  };

  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-4xl mx-auto px-4 flex items-center justify-between h-16">
        <span
          className="font-extrabold text-xl text-indigo-700 tracking-tight cursor-default select-none flex gap-0.5"
          style={{ userSelect: "none" }}
          onMouseEnter={(e) => {
            const letters = e.currentTarget.querySelectorAll(".wave-letter");
            letters.forEach((el, i) => {
              (el as HTMLElement).style.animation = `wave 0.6s ${i * 0.06}s 1`;
            });
          }}
        >
          {"PokéInv".split("").map((char, i) => (
            <span
              key={i}
              className="wave-letter inline-block"
              style={{ display: "inline-block" }}
              onAnimationEnd={(e) => {
                (e.currentTarget as HTMLElement).style.animation = "";
              }}
            >
              {char === " " ? "\u00A0" : char}
            </span>
          ))}
        </span>
        <div className="hidden sm:flex items-center gap-6 ml-8">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-3 py-2 rounded-lg font-medium transition-all duration-200 ${
                location.pathname === link.to
                  ? "bg-indigo-100 text-indigo-700 shadow"
                  : "text-gray-600 hover:bg-indigo-50 hover:text-indigo-700"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
        {user && (
          <div className="hidden sm:flex items-center gap-3 ml-auto">
            <Link
              to="/profile"
              className="text-sm font-semibold text-indigo-700 hover:text-indigo-500 hover:underline rounded px-2 py-1 transition-all duration-200 focus:outline-none"
              title="Go to Profile"
            >
              {user.displayName || user.email}
            </Link>
            <button
              onClick={handleLogout}
              className="bg-indigo-600 text-white px-4 py-1.5 rounded-lg font-medium shadow hover:bg-indigo-700 transition-all duration-200"
            >
              Log Out
            </button>
          </div>
        )}
        {/* Hamburger */}
        <button
          className="sm:hidden p-2 rounded focus:outline-none hover:bg-indigo-50 transition"
          onClick={() => setOpen(!open)}
          aria-label="Toggle navigation"
        >
          <svg
            className="w-7 h-7 text-indigo-700"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d={
                open
                  ? "M6 18L18 6M6 6l12 12"
                  : "M4 6h16M4 12h16M4 18h16"
              }
            />
          </svg>
        </button>
      </div>
      {/* Mobile menu */}
      {open && (
        <div className="sm:hidden bg-white shadow-lg rounded-b-xl px-4 py-4 animate-slide-down">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block px-4 py-3 rounded-lg font-medium mb-2 transition-all duration-200 ${
                location.pathname === link.to
                  ? "bg-indigo-100 text-indigo-700 shadow"
                  : "text-gray-700 hover:bg-indigo-50 hover:text-indigo-700"
              }`}
              onClick={() => setOpen(false)}
            >
              {link.label}
            </Link>
          ))}
          {user && (
            <div className="flex flex-col items-start mt-2">
              <Link
                to="/profile"
                className="mb-2 text-sm font-semibold text-indigo-700 hover:text-indigo-500 hover:underline rounded px-2 py-1 transition-all duration-200"
                onClick={() => setOpen(false)}
                title="Go to Profile"
              >
                {user.displayName || user.email}
              </Link>
              <button
                onClick={handleLogout}
                className="bg-indigo-600 text-white px-4 py-1.5 rounded-lg font-medium shadow hover:bg-indigo-700 transition-all duration-200"
              >
                Log Out
              </button>
            </div>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;

